import React, { useState, useEffect, useRef } from "react";
import { forceSatoshiFormat } from "../../../Helper";

const RollingBalance = ({ value, duration = 1000 }) => {
    // Handle undefined/null values by defaulting to 0
    const safeValue = value ?? 0;
    const [displayValue, setDisplayValue] = useState(safeValue);
    const previousValueRef = useRef(safeValue);
    const animationRef = useRef(null);

    const easeOutExpo = (t) => {
        return t === 1 ? 1 : 1 - Math.pow(2, -10 * t);
    };

    useEffect(() => {
        const startValue = parseFloat(previousValueRef.current) || 0;
        const endValue = parseFloat(safeValue) || 0;

        if (startValue === endValue) return;

        const startTime = performance.now();

        const animate = (currentTime) => {
            const elapsedTime = currentTime - startTime;
            const progress = Math.min(elapsedTime / duration, 1);
            const easedProgress = easeOutExpo(progress);

            const currentValue = startValue + (endValue - startValue) * easedProgress;
            setDisplayValue(currentValue);

            if (progress < 1) {
                animationRef.current = requestAnimationFrame(animate);
            } else {
                previousValueRef.current = endValue;
            }
        };

        if (animationRef.current) {
            cancelAnimationFrame(animationRef.current);
        }
        animationRef.current = requestAnimationFrame(animate);

        return () => {
            if (animationRef.current) {
                cancelAnimationFrame(animationRef.current);
            }
        };
    }, [safeValue, duration]);

    return (
        <span className="rolling-digit">
            {forceSatoshiFormat(displayValue)}
        </span>
    );
};

export default RollingBalance;
